/**
 * Per-term FAQ for /rates/{term-slug}. Copy lives in site/content/rates.json (shared with the backend prerender so
 * crawlers see the exact FAQ the browser renders). Pure module — safe to import from tests.
 */
import RATES from "../../site/content/rates.json";

export function buildFaqItems(termLabel, rate, rateType) {
  const F = RATES.faq;
  const rateStr = rate != null ? `${Number(rate).toFixed(2)}%` : "today's best rate";
  const isVariable = rateType === "variable";
  const cfg = F.per_term[termLabel] || F.default;
  const fill = (t) => t.replace(/\{Term\}/g, termLabel).replace(/\{term\}/g, termLabel.toLowerCase()).replace(/\{rate\}/g, rateStr).replace(/\{strategy\}/g, cfg.strategy);
  return [
    [fill(F.q1[0]), fill(F.q1[1])],
    [fill(F.q2_name), cfg.why],
    [isVariable ? F.q3_variable_name : fill(F.q3_fixed_name), cfg.strategyAnswer],
    ...F.shared,
    [F.rate_change_name, isVariable ? F.rate_change_variable : F.rate_change_fixed],
    ...F.tail,
  ];
}

export function buildFaqEntities(termLabel, rate, rateType) {
  return buildFaqItems(termLabel, rate, rateType).map(([name, text]) => ({ "@type": "Question", name, acceptedAnswer: { "@type": "Answer", text } }));
}
